export default {
  name: {
    value: '',
    error: null,
    name: 'name',
    placeholder: 'First Name',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  email: {
    value: '',
    error: null,
    name: 'email',
    placeholder: 'Email Address',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: 'email',
    hasBlurred: false,
    inputType: 'text',
  },
  subject: {
    value: '',
    error: null,
    name: 'subject',
    placeholder: 'Subject Line',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  message: {
    value: '',
    error: null,
    name: 'message',
    placeholder: 'Message',
    breed: 'textarea',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'textarea',
		charLimit: 150
  },
}



/** WEBPACK FOOTER **
 ** ./src/forms/help.js
 **/